import { useContext } from 'react';

import { Flex, VFlex } from '@/components/base';
import service from '@/services/index';
import type { TOPIC_2_TYPE } from '@/types/taxonomyConst';

import TaxonomyContext from '../../../context/TaxonomyContext';
import TopicTypeLabel from '../../TopicTypeLabel/TopicTypeLabel';
import DescriptionEditor from './DescriptionEditor';
import TitleEditor from './TitleEditor';

type Props = {
  topic?: Topic2T<TOPIC_2_TYPE>;
};

const Topic2Header = (props: Props) => {
  const { topic } = props;
  const { fetchTopics } = useContext(TaxonomyContext);
  return (
    <VFlex
      style={{ minHeight: 84, transform: 'translateX(-12px)' }}
      g={4}
      f={1}
    >
      {topic && (
        <Flex a="flex-end" style={{ height: 40 }} g={4}>
          <TitleEditor
            key={topic.name}
            title={topic.name}
            updateTitle={async (title) => {
              await service.taxonomy.updateTopicTitle(topic.alias, title || '');
              fetchTopics();
            }}
          />
          <Flex padding="8px 0px">
            <TopicTypeLabel type={topic.category} />
          </Flex>
        </Flex>
      )}

      <DescriptionEditor
        key={topic?.desc}
        desc={topic?.desc}
        onDoneClick={async (desc) => {
          if (!topic) throw new Error('Topic is not exist');
          await service.taxonomy.updateTopicDesc(topic?.alias, desc || '');
        }}
      />
    </VFlex>
  );
};

export default Topic2Header;
